import PropTypes from "prop-types";
import React from "react";

import {
  Section,
  // Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { Link } from "components/CallToAction";

/**
 * @function PowerMove
 * @param {element} children Hero content, e.g. Hero Image, Video, or Sizing element(s)
 */
export const PowerMove = ({ children }) => (
  <Section>
    {children}
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 34px 46px 44px 46px;
        }
        @media screen and (min-width: ${getSize("tablet720")}) {
          width: 360px;
        }
        @media screen and (min-width: ${getSize("tablet720")}) {
          width: 384px;
        }
        @media screen and (min-width: ${getSize("tablet960")}) {
          width: auto;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 74px 80px;
        }
      `}
    >
      <Header2
        css={`
          width: 210px;
          @media screen and (min-width: ${getSize("mobile480")}) {
            width: 100%;
          }
          @media screen and (min-width: ${getSize("tablet720")}) {
            width: 210px;
          }
          @media screen and (min-width: ${getSize("tablet960")}) {
            width: 100%;
          }
        `}
      >
        {"Make a Power Move"}
        <Underlined
          css={`
            @media screen and (min-width: ${getSize(
                "default"
              )}) and (max-width: 479px) {
              margin-top: 17px;
            }
            @media screen and (min-width: ${getSize(
                "mobile480"
              )}) and (max-width: 719px) {
              margin-top: 20px;
            }
            @media screen and (min-width: ${getSize("desktop1920")}) {
              margin-top: 20px;
            }
          `}
        />
      </Header2>
      <Paragraph
        css={`
          width: 95%;
          @media screen and (min-width: ${getSize(
              "default"
            )}) and (max-width: 479px) {
            margin-top: 23px;
          }
          @media screen and (min-width: ${getSize(
              "mobile480"
            )}) and (max-width: 719px) {
            margin-top: 23px;
          }
          @media screen and (min-width: ${getSize("tablet720")}) {
            margin-top: 22px;
            width: 100%;
          }
          @media screen and (min-width: ${getSize("tablet768")}) {
            width: 285px;
          }
          @media screen and (min-width: ${getSize("tablet960")}) {
            width: 360px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            width: 471px;
          }
        `}
      >
        {
          "Take control of your energy consumption and lose your dependence on the grid."
        }
      </Paragraph>
      <div
        css={`
          margin: 22px 0px 4px 0px;
          @media screen and (min-width: ${getSize(
              "mobile480"
            )}) and (max-width: 719px) {
            margin: 27px 0px 4px 0px;
          }
          @media screen and (min-width: ${getSize("tablet720")}) {
            margin: 23px 0px 4px 0px;
          }
          @media screen and (min-width: ${getSize("tablet768")}) {
            margin: 24px 0px 4px 0px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            margin: 35px 0px 6px 0px;
          }
        `}
      >
        <Link to="/get-a-preliminary-proposal">{"Get an Estimate"}</Link>
      </div>
    </Card>
  </Section>
);

PowerMove.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
};
